import { Component } from '@angular/core';

@Component({
  selector: 'tw-access-required',
  imports: [],
  template: 'You do not have access to this page!',
})
export class AccessRequiredComponent {}
